/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

import * as Sentry from "@sentry/vue";

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// VeeValidate
import VeeValidate, { Validator } from "vee-validate";
import CpfValidator from "./validators/cpf.validator.js";
import TimeValidator from "./validators/time.validator.js";
import pt_BR from "vee-validate/dist/locale/pt_BR";

Validator.extend("cpf", CpfValidator);
Validator.extend("is_time", TimeValidator);

Vue.use(VeeValidate, {
  locale: "pt_BR",
  dictionary: {
    pt_BR: {
      messages: pt_BR.messages,
    },
  },
});

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// AWS Amplify +  AWS Amplify Vue for Auth with Cognito
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsConfig from "@/aws-exports";

// Configure the default language and translated strings
import { I18n } from "@aws-amplify/core";
import { strings } from "@/utils/strings";
I18n.setLanguage("pt-br");
I18n.putVocabularies(strings);

// Firebase
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDzAX4BFWfaf7a3LZGEdoX6OF3Nfd8uN5k",
  authDomain: "caravanas-publico.firebaseapp.com",
  projectId: "caravanas-publico",
  storageBucket: "caravanas-publico.appspot.com",
  messagingSenderId: "83367837306",
  appId: "1:83367837306:web:771da08134eb06623785c3",
  measurementId: "G-NW2SGR5Z1H",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

Vue.config.productionTip = false;

Amplify.configure(awsConfig);
Vue.use(AmplifyPlugin, AmplifyModules);

// register infinite scroll globally
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import VueNativeSock from "vue-native-websocket";
import wsStore from "./store/websocket";
const reconnection = window.location.href.indexOf("localhost") === -1;
Vue.use(VueNativeSock, process.env.VUE_APP_WS_URL, {
  store: wsStore,
  reconnection,
  reconnectionDelay: 30000,
  format: "json",
});

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY,
  integrations: [
    // Or omit `router` if you're not using vue-router
    Sentry.browserTracingIntegration({ router }),

    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      unblock: [".sentry-unblock, [data-sentry-unblock]"],
      unmask: [".sentry-unmask, [data-sentry-unmask]"],
    }),
    Sentry.browserTracingIntegration(),
  ],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  tracesSampleRate: 1.0,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// Export analytics instance for reuse
export { analytics };
